import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import pick from 'lodash.pick';
import moment from '@shared/services/moment';
import Shareable from '@shared/models/shareable';
import BusySpan from '@shared/models/busy_span';
import TimeSpan from '@shared/models/time_span';
import Person from '@shared/models/person';
import PersonSet from '@shared/models/person_set';

var Meetup = /*#__PURE__*/function (_Shareable) {
  _inherits(Meetup, _Shareable);

  var _super = _createSuper(Meetup);

  function Meetup() {
    _classCallCheck(this, Meetup);

    return _super.call(this);
  }

  _createClass(Meetup, [{
    key: "hasParticipants",
    value: function hasParticipants() {
      return this.people.length > 0;
    }
  }, {
    key: "hasMeetupTimeSelected",
    value: function hasMeetupTimeSelected() {
      return !this.selectedTime.isNull();
    } // Returns a list of people who are busy at a particular moment

  }, {
    key: "getBusyPeopleAtMoment",
    value: function getBusyPeopleAtMoment(busyMoment) {
      var _this = this;

      return new PersonSet(this.people.filter(function (person) {
        return _this.getBusySpansByPerson(person).some(function (busySpan) {
          return busySpan.time.containsMoment(busyMoment);
        });
      }));
    }
  }, {
    key: "getBusySpansByPerson",
    value: function getBusySpansByPerson(person) {
      return this.busySpans.filter(function (busySpan) {
        return busySpan.person.equals(person);
      });
    }
  }, {
    key: "hasBusySpansByPerson",
    value: function hasBusySpansByPerson(person) {
      return this.getBusySpansByPerson(person).length > 0;
    }
  }, {
    key: "isNew",
    value: function isNew() {
      return !this.hasBusySpans() && !this.hasParticipants();
    }
  }, {
    key: "hasBusySpans",
    value: function hasBusySpans() {
      return this.busySpans.length > 0;
    }
  }], [{
    key: "fromPlainObject",
    value: function fromPlainObject(obj) {
      var rawFields = ['id', 'name', 'location', 'timezone', 'dates'];
      var meetup = new this(); // Allows ServerMeetup to construct an instance of itself through this method

      Object.assign(meetup, pick(obj, rawFields));
      var created = obj.created,
          owner = obj.owner,
          timeRange = obj.timeRange,
          people = obj.people,
          busySpans = obj.busySpans,
          selectedTime = obj.selectedTime;
      meetup.created = moment.unix(created);
      meetup.owner = Person.fromPlainObject(owner);
      meetup.timeRange = TimeSpan.fromPlainObject(timeRange);
      meetup.people = people.map(function (person) {
        return Person.fromPlainObject(person);
      });
      meetup.busySpans = busySpans.map(function (busySpan) {
        return BusySpan.fromPlainObject(busySpan);
      });
      meetup.selectedTime = TimeSpan.fromPlainObject(selectedTime);
      return meetup;
    }
  }, {
    key: "shareableFields",
    value: function shareableFields() {
      return ['id', 'name', 'location', 'created', 'owner', 'timezone', 'dates', 'timeRange', 'people', 'busySpans', 'selectedTime'];
    }
  }]);

  return Meetup;
}(Shareable);

export { Meetup as default };
export var NullMeetup = /*#__PURE__*/function (_Meetup) {
  _inherits(NullMeetup, _Meetup);

  var _super2 = _createSuper(NullMeetup);

  function NullMeetup() {
    _classCallCheck(this, NullMeetup);

    return _super2.apply(this, arguments);
  }

  _createClass(NullMeetup, [{
    key: "isNull",
    value: function isNull() {
      return true;
    }
  }]);

  return NullMeetup;
}(Meetup);